<script>
    import Spinner from './Spinner.svelte';

    export let disabled = false;
    export let type = 'default';

    export let container = 'button';
    export let title = '';
    export let rounded = true;
    export let bordered = true;
    export let paddings = true;
    export let margins = true;
    export let shadows = true;
    export let loading = false;
    export let color = false;
    export let size = 'normal';
    export let styles = '';
    let classes = '';
    export {classes as class};

    let hover;
    let buttonClasses;
    $: {
        switch (type) {
            case 'secondary':
                buttonClasses = 'bookly:text-slate-600 bookly:bg-white bookly:border-slate-600';
                hover = 'bookly:hover:text-slate-50 bookly:hover:bg-slate-400 bookly:hover:border-slate-400';
                break;
            case 'white':
                buttonClasses = 'bookly:text-slate-600 bookly:bg-white bookly:border-slate-600';
                hover = 'bookly:hover:text-slate-50 bookly:hover:bg-gray-400 bookly:hover:border-gray-400';
                break;
            case 'transparent':
                buttonClasses = (color ? color : 'bookly:text-slate-600') + ' bookly:bg-transparent bookly:border-slate-600';
                hover = 'bookly:hover:text-slate-50 bookly:hover:bg-gray-400 bookly:hover:border-gray-400';
                break;
            case 'bookly':
                buttonClasses = 'text-bookly bookly:not-hover:bg-white border-bookly';
                hover = 'bookly:hover:text-white hover:bg-bookly bookly:hover:opacity-80 hover:border-bookly';
                break;
            case 'bookly-active':
                buttonClasses = 'bg-bookly bookly:text-white border-bookly';
                hover = 'bookly:hover:text-slate-100 hover:bg-bookly hover:border-bookly';
                break;
            case 'bookly-gray':
                buttonClasses = 'text-bookly bookly:not-hover:bg-gray-200 border-bookly';
                hover = 'bookly:hover:text-white hover:bg-bookly hover:border-bookly';
                break;
            case 'link':
                buttonClasses = 'bookly:border-none bookly:rounded-none bookly:p-0 bookly:focus:border-none bookly:focus:outline-none ' + (disabled ? 'bookly:text-gray-600' : 'text-bookly');
                hover = 'bookly:hover:text-gray-600';
                rounded = false;
                bordered = false;
                paddings = false;
                margins = false;
                shadows = false;
                size = 'link';
                break;
            case 'calendar':
                buttonClasses = '';
                hover = 'bookly:hover:opacity-80';
                rounded = false;
                bordered = false;
                paddings = false;
                margins = false;
                shadows = false;
                break;
            case 'calendar-normal':
                buttonClasses = 'text-bookly border-bookly bookly:rounded-none bookly:m-0 ' + (disabled ? 'bookly:bg-slate-50 hover:text-bookly' : 'bookly:bg-white');
                hover = 'hover:bg-bookly hover:border-bookly ' + (disabled ? 'hover:text-bookly' : 'bookly:hover:text-white');
                rounded = false;
                bordered = false;
                paddings = false;
                margins = false;
                shadows = false;
                break;
            case 'calendar-active':
                buttonClasses = 'bg-bookly bookly:text-white border-bookly bookly:rounded-none bookly:m-0';
                hover = 'bookly:hover:text-slate-200';
                rounded = false;
                bordered = false;
                paddings = false;
                margins = false;
                shadows = false;
                break;
            case 'calendar-inactive':
                buttonClasses = 'bookly:text-gray-400 border-bookly bookly:rounded-none bookly:m-0 ' + (disabled ? 'bookly:bg-slate-50' : 'bookly:bg-white');
                hover = 'bookly:hover:text-white bookly:hover:bg-gray-400 hover:border-bookly';
                rounded = false;
                bordered = false;
                paddings = false;
                margins = false;
                shadows = false;
                break;
            default:
                buttonClasses = 'bookly:text-black bookly:bg-gray-100 bookly:border-default-border';
                hover = 'bookly:hover:text-slate-50 bookly:hover:bg-gray-400'
                break;
        }
        if (!shadows) {
            buttonClasses += ' bookly:shadow-none';
        }
        if (!disabled && !loading && shadows) {
            buttonClasses += ' bookly:active:shadow-md';
        }
        if (!disabled && !loading) {
            buttonClasses += ' ' + hover;
        }
        if (rounded) {
            buttonClasses += ' bookly:rounded';
        }
        if (bordered) {
            buttonClasses += ' bookly:border bookly:border-solid';
        }
        if (paddings) {
            switch (size) {
                case 'lg':
                    buttonClasses += ' bookly:px-5 bookly:py-0';
                    break;
                default:
                    buttonClasses += ' bookly:px-4 bookly:py-0';
                    break;
            }
        }
        if (margins) {
            buttonClasses += ' bookly:ms-2 bookly:my-0 bookly:me-0';
        }
        switch (size) {
            case 'link':
            case 'custom':
                break;
            case 'lg':
                buttonClasses += ' bookly:text-xl bookly:h-14';
                break;
            default:
                buttonClasses += ' bookly:text-lg bookly:h-10';
                break;
        }
        if (margins) {
            buttonClasses += ' bookly:relative';
        }
    }
</script>
{#if container === 'div'}
    {#if !disabled}
        <div
                title={title}
                class="{classes} {buttonClasses} bookly:drop-shadow-none bookly:box-border bookly:text-center bookly:flex bookly:items-center bookly:justify-center bookly:focus:outline-hidden bookly:cursor-pointer"
                style="{styles}"
                {disabled}
                on:click|stopPropagation
                role="button"
                tabindex="0"
                on:keypress|stopPropagation
        >
            {#if loading}
        <span class="bookly:absolute bookly:inset-1">
            <Spinner full_size={true}/>
        </span>
            {/if}
            <span class:bookly:opacity-0={loading}>
            <slot></slot>
        </span>
        </div>
    {:else}
        <div
                title={title}
                class="{classes} {buttonClasses} bookly:drop-shadow-none bookly:box-border bookly:text-center bookly:flex bookly:items-center bookly:justify-center pointer-events-none bookly:opacity-50 bookly:pointer-events-none"
                style="{styles}"
                {disabled}
        >
            {#if loading}
        <span class="bookly:absolute bookly:inset-1">
            <Spinner full_size={true}/>
        </span>
            {/if}
            <span class:bookly:opacity-0={loading}>
            <slot></slot>
        </span>
        </div>
    {/if}
{:else}
    <button
            type="button"
            title={title}
            class="{classes} {buttonClasses} bookly:drop-shadow-none bookly:box-border"
            class:bookly:cursor-pointer={!disabled}
            class:bookly:pointer-events-none={disabled}
            class:bookly:opacity-50={disabled}
            style="{styles}"
            disabled={disabled||loading}
            on:click|stopPropagation
    >
        {#if loading}
        <span class="bookly:absolute bookly:inset-1">
            <Spinner full_size={true}/>
        </span>
        {/if}
        <span class:bookly:opacity-0={loading}>
        <slot></slot>
    </span>
    </button>
{/if}